import { render, staticRenderFns } from "./VehicleCatalogDialog.vue?vue&type=template&id=6fe552ba"
import script from "./VehicleCatalogDialog.vue?vue&type=script&lang=js"
export * from "./VehicleCatalogDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports